/* ==========================================================================
   Brake Fluid Boiling Point Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-bfc]');
  if (!root) return;

  /* Dry and wet boiling points in Fahrenheit. Wet is defined as 3.7% water by
     volume, which is the federal test condition. */
  var FLUID = {
    dot3:  { name: 'DOT 3',  dry: 401, wet: 284 },
    dot4:  { name: 'DOT 4',  dry: 446, wet: 311 },
    dot51: { name: 'DOT 5.1',dry: 500, wet: 356 },
    dot4ll:{ name: 'DOT 4 LV', dry: 509, wet: 356 }
  };
  var WET_PCT = 3.7;
  /* Percentage points of water absorbed per year. */
  var ABSORB = { dry: 0.9, moderate: 1.5, humid: 2.4 };

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var f = FLUID[input.type] || FLUID.dot4;
    if (!isFinite(input.months) || input.months < 0) {
      return { ok: false, errors: ['Enter how many months since the fluid was changed.'] };
    }

    var rate = ABSORB[input.climate] || ABSORB.moderate;
    var moisture = Math.min(WET_PCT * 1.6, (input.months / 12) * rate);

    /* Boiling point falls steeply at first and then flattens. Linear between
       dry and wet is the standard approximation up to the 3.7% test point. */
    var frac = Math.min(1, moisture / WET_PCT);
    var bp = f.dry - (f.dry - f.wet) * frac;
    if (moisture > WET_PCT) bp -= (moisture - WET_PCT) * 8;

    var status, warnings = [];
    if (moisture >= 3.0) {
      status = { key: 'now', label: num(bp, 0) + 'F',
                 note: 'Around ' + num(moisture, 1) + '% water. This fluid is past its service life and should be flushed.' };
    } else if (moisture >= 2.0) {
      status = { key: 'soon', label: num(bp, 0) + 'F',
                 note: 'Around ' + num(moisture, 1) + '% water. Change it at the next service.' };
    } else if (moisture >= 1.0) {
      status = { key: 'monitor', label: num(bp, 0) + 'F',
                 note: 'Around ' + num(moisture, 1) + '% water. Still serviceable.' };
    } else {
      status = { key: 'good', label: num(bp, 0) + 'F',
                 note: 'Around ' + num(moisture, 1) + '% water. Close to fresh.' };
    }

    if (input.track && moisture > 1.0) {
      warnings.push('Hard use puts far more heat into the fluid than street driving. At this moisture level a long descent or a track session can boil it, and boiling fluid means a pedal that goes to the floor.');
      if (status.key === 'monitor') status.key = 'soon';
    }

    return {
      ok: true, errors: [], warnings: warnings, status: status,
      figures: [
        { label: 'Estimated boiling point', value: num(bp, 0) + ' F',
          sub: 'Down from ' + num(f.dry, 0) + 'F when it was new.' },
        { label: 'Estimated moisture', value: num(moisture, 1) + '%',
          sub: 'Fluid is considered fully wet at ' + num(WET_PCT, 1) + '%.' }
      ],
      rows: [
        { head: f.name },
        { label: 'Dry boiling point', value: num(f.dry, 0) + ' F' },
        { label: 'Wet boiling point', value: num(f.wet, 0) + ' F' },
        { label: 'Estimated now', value: num(bp, 0) + ' F' },
        { label: 'Lost so far', value: num(f.dry - bp, 0) + ' F' },
        { head: 'Service' },
        { label: 'Age', value: num(input.months, 0) + ' months' },
        { label: 'Absorption rate', value: num(rate, 1) + '% per year' },
        { label: 'Recommended interval', value: input.track ? '12 months' : '24 months' }
      ]
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "type",
          "key": "t",
          "type": "select"
      },
      {
          "name": "months",
          "key": "m",
          "type": "number"
      },
      {
          "name": "climate",
          "key": "c",
          "type": "select"
      },
      {
          "name": "track",
          "key": "tr",
          "type": "checkbox"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-bfc__figure">'
        + '<div class="pc-bfc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-bfc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-bfc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-bfc__row pc-bfc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-bfc__row">'
        + '<span class="pc-bfc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-bfc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_BFC = { compute: compute };
})();
